export default "<app-browser-support *ngIf=\"browserNotSupported\"></app-browser-support>\r\n<app-home *ngIf=\"!browserNotSupported\"></app-home>\r\n"